import { render, staticRenderFns } from "./MyAccountDefault.vue?vue&type=template&id=27f9aba1&"
import script from "./MyAccountDefault.vue?vue&type=script&lang=ts&"
export * from "./MyAccountDefault.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountDefault.vue?vue&type=style&index=0&id=27f9aba1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports